import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { threadsResponseApi } from "../../api";
import { delete_user_data_from_client_side, isValidEpochTime } from "../../utils/common";
import ChatCard from "./mentee_interactions/ChatCard";
import { parseAnswerToHtml } from "./mentee_interactions/AnswerParser";
import UnableToAnswerChatCard from "./mentee_interactions/UnableToAnswerChatCard";

interface ThoughtsProps {
    prompt: string;
    response: string | string[] | JSX.Element;
    citations?: string | string[] | JSX.Element[] | { text: string; link: string } | { text: string; link: string }[];
    followupQuestions?: string[];
    thread_id: string;
    selectedIndex?: number;
    checkBoxValue?: string;
    from: string;
}

interface GeneratedChatListProps {
    generatedChat: JSX.Element[];
}
const GeneratedChatList = ({ generatedChat }: GeneratedChatListProps) => {
    return <div className=" items-center justify-center mb-28 w-full ">{generatedChat.map((chat, index) => React.cloneElement(chat, { key: index }))}</div>;
};

const ShowInteractions = ({ prompt: initialPrompt, citations, thread_id, selectedIndex, checkBoxValue, from }: ThoughtsProps) => {
    // const checkedValue = "good"
    const [isError, setIsError] = useState(false);
    const navigate = useNavigate();
    const [generatedChat, setGeneratedChat] = useState<JSX.Element[]>([]);
    const lastCardRef = useRef<HTMLDivElement>(null);
    const [isLoading, setIsLoading] = useState(false);
    let index = 0;
    let isIndexMatched = false;

    async function fetchAndSetThoughts(id: string) {
        try {
            const dislikedThreadsResponse = await threadsResponseApi(id);
            if (dislikedThreadsResponse == null) {
                throw new Error();
            }
            const data = await dislikedThreadsResponse.data;
            setGeneratedChat([]);

            if (data.error !== undefined || data.error === "") {
                const errorCard = (
                    <ChatCard
                        key={generatedChat.length}
                        prompt={""}
                        response={"<div className='flex  justify-center h-16 w-full font-bold p-6'>Oops, something went wrong!  </div>"}
                        from={"ShowInteraction"}
                        feed_back={""}
                        citations={[]}
                        followupQuestions={[]}
                        conversation_id={id}
                        selectedIndex={selectedIndex}
                        isIndexMatched={isIndexMatched}
                        checkedValue={checkBoxValue}
                    />
                );
                setGeneratedChat(prev => [...prev, errorCard]); // Wrap errorCard in an array
            }
            for (const item of data) {
                if (index == selectedIndex) {
                    isIndexMatched = true;
                } else {
                    isIndexMatched = false;
                }
                const citationWithLink = item.citations;
                const { answerHtml, citations, followupQuestions } = parseAnswerToHtml(
                    item.response,
                    item.followup_questions,
                    item.caselets,
                    // onCitationClicked,
                    // citationWithLink
                    // onFollowupQuestionClicked
                );

                let feed_back_value = "not_available";
                if (item.feed_back !== undefined || item.feed_back !== "") {
                    feed_back_value = item.feed_back;
                } 
                // else {
                //     feed_back_value = "not_available";
                // }
                if (from === "like&dislike") {
                    const newChat = (
                        <ChatCard
                            key={generatedChat.length}
                            prompt={item.query}
                            response={answerHtml}
                            citations={citationWithLink}
                            followupQuestions={ followupQuestions}
                            feed_back={item.feed_back}
                            conversation_id={id}
                            selectedIndex={selectedIndex}
                            isIndexMatched={isIndexMatched}
                            from={"ShowInteraction"}
                            checkedValue={checkBoxValue}
                            unableToAnswer={false}
                        />
                    );
                    setGeneratedChat(prevChat => [...prevChat, newChat]);
                    index++;
                } else {
                    const newChat =
                    citationWithLink.length === 0 ? (
                            <UnableToAnswerChatCard
                                key={generatedChat.length}
                                prompt={item.query}
                                response={answerHtml}
                                citations={citationWithLink}
                                followupQuestions={ followupQuestions}
                                feed_back={item.feed_back}
                                conversation_id={id}
                                selectedIndex={selectedIndex}
                                isIndexMatched={isIndexMatched}
                                from={"ShowInteraction"}
                                checkedValue={checkBoxValue}
                                unableToAnswer={citationWithLink.length === 0 ? true : false}
                            />
                        ) : (
                            <ChatCard
                                key={generatedChat.length}
                                prompt={item.query}
                                response={answerHtml}
                                citations={citationWithLink}
                                followupQuestions={ followupQuestions}
                                feed_back={item.feed_back}
                                conversation_id={id}
                                selectedIndex={selectedIndex}
                                isIndexMatched={isIndexMatched}
                                from={"ShowInteraction"}
                                checkedValue={checkBoxValue}
                                unableToAnswer={false}
                            />
                        );
                    setGeneratedChat(prevChat => [...prevChat, newChat]);
                    index++;
                }
            }
        } catch (err) {
            console.log("Error occurred: ", {err});
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        setGeneratedChat([]);
        if (isValidEpochTime(thread_id)) {
            fetchAndSetThoughts(thread_id);
        } else {
            setIsError(false);
        }
    }, [thread_id, selectedIndex]);
    useEffect(() => {
        if (lastCardRef.current) {
            lastCardRef.current.scrollIntoView({
                behavior: "smooth",
                block: "center", // This aligns the element to the center vertically
                inline: "nearest" // This ensures proper horizontal alignment
            });
        }
    }, [generatedChat]);

    return (
        <div className="my-4 ">
            <div className="h-auto overflow-y-scroll">
                <div ref={lastCardRef} />
                <div className="flex justify-center items-center shrink-0 pb-6">
                    <GeneratedChatList generatedChat={generatedChat} />
                </div>
            </div>
        </div>
    );
};

export default ShowInteractions;
